export const AudioModeDefintions = [
  {
    value: "driverManaged",
    details: "The driver can turn on or off audio recording using settings on the Xirgocam"
  },
  {
    value: "off",
    details: "Xirgocam will not record any audio. The driver cannot change this setting"
  }
]